"use client";
import React, { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button } from "../UIComponents";

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  containerClassName?: string;
  className?: string;
  title?: string;
  contentClassName?: string;
};

const Modal = ({
  isOpen,
  onClose,
  children,
  containerClassName,
  className,
  title,
  contentClassName,
}: TProps) => {
  const [mounted, setMounted] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  // useOutsideClickDetector(popupRef, () => {
  //   onClose();
  // });

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    const disableScroll = () => {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
      document.documentElement.style.overflow = "hidden";
    };

    const enableScroll = () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
      document.documentElement.style.overflow = "";
    };

    if (isOpen) {
      disableScroll();
    } else {
      enableScroll();
    }

    return enableScroll;
  }, [isOpen]);

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <div
      className={classNames(
        "backdrfop-blur-sm fixed inset-0 z-40 flex flex-col items-center justify-center bg-[#2B2342] bg-opacity-80 px-2 transition-opacity duration-200",
        {
          "opacity-100": isOpen,
          "pointer-events-none opacity-0": !isOpen,
        },
        containerClassName,
      )}
    >
      <div
        className={classNames(
          "flex h-fit w-full !max-w-[440px] flex-col overflow-hidden rounded-[16px] border bg-white text-base text-black shadow-inner",
          className,
        )}
        ref={popupRef}
      >
        <div
          className={classNames("flex w-full items-center gap-2 p-3", {
            "mb-4 justify-between border-b-[1px]": !!title,
            "justify-end": !title,
          })}
        >
          {title && (
            <span className="text-wrap text-md font-bold lg:text-base">
              {title}
            </span>
          )}
          <Button
            type="button"
            onClick={onClose}
            className="h-10 w-10 lg:h-12 lg:w-12"
          >
            <CloseRoundedIcon sx={{ fontSize: 24 }} />
          </Button>
        </div>
        <div
          className={classNames(
            "max-h-[calc(100vh-10rem)] overflow-y-auto px-4 pb-4",
            contentClassName,
          )}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
